<template>
  <ul class="tab-header">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: "TabHeader",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.tab-header {
  list-style: none;
  margin-bottom: 0;
  .tab-bordered & {
    border-bottom: 1px solid $secondary;
    height: 61px;
    text-align: justify;
    display: flex;
    justify-content: space-between;
  }
  @include mq-up(md) {
    .tab-filled & {
      display: flex;
      justify-content: space-between;
      height: 53px;
    }
    .tab-filled.-tab-orange & {
      border-bottom: 1px solid $orange;
    }
    .tab-filled.-tab-green & {
      border-bottom: 1px solid $green;
    }
  }
  @include mq-down(md) {
    .tab-filled & {
      border-bottom: none;
    }
  }
  .tab-sticky & {
    display: flex;
    justify-content: space-between;
  }
}
</style>
